export default "__VITE_ASSET__45245f52__"